import { fetchAdditions } from '#action/fetch';
import { FETCH_LOCATIONS } from '#action/types';
import { getDateRange } from '#helper';

export const fetchLocations = ({ deviceId }, period) => dispatch => {
  let locationsURI = `device/distinct/${deviceId}/locations`;

  if (period) {
    const { start, end } = period;
    const range = getDateRange(start, end);
    locationsURI += `/${range.start}/${range.end}`;
  }
  return dispatch(fetchAdditions(locationsURI, FETCH_LOCATIONS));
};
